import React from "react";
import Heading from "../Products/Heading";
import Product from "../Products/Product";
import { useNavigate } from "react-router-dom";
import { currentSpices } from "../../../constants";

const Spices = () => {
  const navigate = useNavigate();

  const SpicesItems = ({ list }) => {
    const handleSpiceClick = (index) => {
      const productItem = list[index];
      const productName = productItem.productName;

      // Optimize SEO-friendly URL slug
      const makeSlug = (name) =>
        String(name).toLowerCase().replace(/\s+/g, "");

      const productSlug = makeSlug(productName);

      navigate(`/product/${productSlug}`, {
        state: { item: productItem },
      });
    };

    return (
      <>
        {list &&
          list.map((spice, index) => (
            <div
              key={index}
              className="w-full cursor-pointer transition-all hover:scale-[1.02]"
              onClick={() => handleSpiceClick(index)}
            >
              <Product
                _id={spice._id}
                img={spice.img}
                alt={`${spice.productName} - Premium Indian Spice Exporter`}
                productName={spice.productName}
                price={spice.price}
                color={spice.color}
                des={
                  spice.des ||
                  `${spice.productName} sourced from top Indian farms. Ideal for global importers, distributors, and wholesale spice buyers.`
                }
                keywords="Indian Spices Exporter, Bulk Spice Supplier, Premium Spice Wholesale, Authentic Indian Spices"
              />
            </div>
          ))}
      </>
    );
  };

  return (
    <section className="w-full pb-10 pt-4">
      {/* SEO Enriched Heading */}
      <Heading heading="Premium Indian Spices – Wholesale Export Quality" />

      {/* Spices Grid */}
      <div className="w-full grid grid-cols-1 md:grid-cols-2 lgl:grid-cols-3 xl:grid-cols-4 gap-10">
        <SpicesItems list={currentSpices} />
      </div>
    </section>
  );
};

export default Spices;
